import { Component, effect, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EnrollPatientDeviceDataService } from '../../services/enroll-patient-device-data.service';
import {
    MenuService,
    PopupConfig,
    PopupService,
    PopupType,
    UserService,
} from 'merlin-library';
import { TranslateService } from '@ngx-translate/core';
import { SubMenuService } from '../../services/sub-menu.service';
import { TransmissionDetailService } from '../../services/transmission-detail.service';
import { LocalizationService } from 'src/core/utilitites/localization.service';
import { HelperService, IdentifierService } from 'merlin-core';
import { DeviceCategoryCd } from '../../../shared/enums/device-category.enum';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-view-edit-patient-profile',
    templateUrl: './view-edit-patient-profile.component.html',
    styleUrls: ['./view-edit-patient-profile.component.scss'],
    standalone: false
})
export class ViewEditPatientProfileComponent implements OnInit, OnDestroy {
    rippleColor = 'rgb(255, 255, 255, 0.3)';
    sectionSelected = 'patient-&-device-data';
    private destroy$ = new Subject<void>();

    patientId: string;
    patientNum: string;
    patientName: string;
    deviceName: string;
    isActivatorClinic: boolean;
    isPrevDeviceChangedOut: boolean;
    rpEnabled: boolean;

    showYellowCard: boolean = false;
    isDtvForICM: boolean = false
    isLPDevice: boolean;

    getUserData() {
        this.userService.getUserProfile(false).pipe(takeUntil(this.destroy$)).subscribe((data) => {
            this.isActivatorClinic = data.activatorClinicFlg;
            this.rpEnabled = data.rpEnabled;
            this.filterActivatorClinicLinks();
        });
    }
    getTransData(){
        this.transmissionDetailsService.getTransmissionDetail().pipe(takeUntil(this.destroy$)).subscribe((transmissionDetails) => {
            this.isPrevDeviceChangedOut = transmissionDetails?.isPrevDeviceChangedOut;
            this.isDtvForICM = transmissionDetails?.info?.displayDtvFlg ?? false;
            this.isLPDevice = transmissionDetails?.info?.currentDeviceCategoryCd === DeviceCategoryCd.LP;
        })
    }

    filterActivatorClinicLinks() {
        if (this.isActivatorClinic) {
            this.sideBarLinks = this.sideBarLinks.filter((sideLink) => {
                return sideLink.enableForActivator;
            });
        }
    }
    sideBarLinks: any[] = [];

    constructor(
        private activatedRoute: ActivatedRoute,
        private enrollService: EnrollPatientDeviceDataService,
        private menuService: MenuService,
        private translateService: TranslateService,
        private subMenuService: SubMenuService,
        private transmissionDetailsService: TransmissionDetailService,
        private localizationService: LocalizationService,
        public identifierService: IdentifierService,
        private popupService: PopupService,
        private userService: UserService,
        private helperService: HelperService,
        private router: Router
    ) {
        effect(() => {
            const lang = this.localizationService.currentLang();
            if (!lang) return;
            this.setSideBarLinks();
        });
       
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
        this.menuService.setSubMenu(null);
    }

    ngOnInit(): void {
        this.setSideBarLinks();
        this.patientId = this.activatedRoute.snapshot.paramMap.get('id');
        this.sectionSelected =
            this.activatedRoute.snapshot.paramMap.get('section');
        this.transmissionDetailsService.setPatientId(+this.patientId);
        this.enrollService.navigateToPatProfileSection( this.sectionSelected);
        
        this.getUserData();
        this.getTransData();
        this.patientId = this.activatedRoute.snapshot.paramMap.get('id');
        if (this.sectionSelected != 'patient-&-device-data') {
            let labels = this.sideBarLinks.filter((sidebar)=> sidebar.link == this.sectionSelected);
          //  this.helperService.setBreadcumb('label.gb.pat_dev_data', labels[0].label);
            this.enrollService
                .getExistingPatient(this.patientId)
                .pipe(takeUntil(this.destroy$))
                .subscribe((res) => {
                    this.patientName = `${res.patient.firstName} ${res.patient.lastName}`;
                    this.deviceName = this.getDeviceName(res);
                    this.patientNum = res.patient.patientNum;
                    this.setSubMenu(res?.patientDevices?.[0]?.isICMDevice || false);
                });
        }

       
        // let labels = this.sideBarLinks.filter((sidebar)=> sidebar.link == this.sectionSelected);
        // this.helperService.setBreadcumb('label.gb.pat_dev_data', labels[0].label);
        this.enrollService.section$.pipe(takeUntil(this.destroy$)).subscribe((section)=>{
            if(section != ''){
                let labels = this.sideBarLinks.filter((sidebar)=> sidebar.link == section);
                this.router.navigate(['patient-list/patient-profile/'+section+'/'+this.patientId])
                this.setSection(section, labels[0].label)
            }
        }) 
    }
    
    setSideBarLinks() {
        this.sideBarLinks = [
            {
                link: 'patient-&-device-data',
                label: this.localizationService.generateLocalizedStr('label.gb.pat_dev_data'),
                enableForActivator: true,
            },
            {
                link: 'transmitter',
                label: this.localizationService.generateLocalizedStr('label.gb.transmitter'),
                enableForActivator: false,
            },
            {
                link: 'follow-up-schedule',
                label: this.localizationService.generateLocalizedStr('label.gb.follow_sched'),
                enableForActivator: false,
            },
            {
                link: 'direct-alerts-notifications',
                label: this.localizationService.generateLocalizedStr('label.gb.alert_notif'),
                enableForActivator: false,
            },
            {
                link: 'baseline-clinical-data',
                label: this.localizationService.generateLocalizedStr('label.gb.baseline_clinical_data'),
                enableForActivator: false,
            },
        ];
    }

    mySectionSelected(section: string) {
        if (section == this.sectionSelected) {
            return true;
        } else {
            return false;
        }
    }

    setSection(section: string, label: string = '') {
        if (this.enrollService.isDeviceFormDirty && (section !== this.sectionSelected)) {
            const dialogConfig: PopupConfig = {
                type: PopupType.Confirm,
                message: this.localizationService.generateLocalizedStr(
                            'msg.cs834.text'),
                confirmText:
                    this.localizationService.generateLocalizedStr(
                        'label.gb.ok'
                    ),
                confirmId: this.identifierService.buttonId(
                    'pcs-location-popup',
                    'ok'
                ),
                cancelId: this.identifierService.buttonId(
                    'pcs-location-popup',
                    'cancel001'
                ),
                cancelText:
                    this.localizationService.generateLocalizedStr(
                        'label.gb.button_cancel'
                    ),
                customPopup: true,
            };
            this.popupService.open(dialogConfig);
            this.popupService.dialogRef
                .afterClosed()
                .subscribe((response: any) => {
                    if (response) {
                        this.enrollService.updateDeviceFormDirty(false);
                        this.sectionSelected = section;
                        this.router.navigate(['patient-list/patient-profile/'+section+'/'+this.patientId])
                    }
                });
        } else {
            this.sectionSelected = section;      
            this.enrollService.updateDeviceFormDirty(false);
         //   this.helperService.setBreadcumb('label.gb.pat_dev_data', label); 
            this.router.navigate(['patient-list/patient-profile/'+section+'/'+this.patientId])
        }
    }

    setPatientHeader(event) {
        
        this.patientName = event.name;
        this.deviceName = event.deviceName;
        this.patientNum = event.num;
    }

    getDeviceName(data) {
        
        let patDevice = data.dropdowns.devices.filter((dev) => {
            return dev.value == data.patientDevices?.[0]?.productId;
        });
        if (patDevice.length == 0) {
            return '';
        }
        return patDevice[0].label;
    }

    getSubMenu(val) {
        this.setSubMenu(val);
    }

    setSubMenu(isIcmDevice: boolean) {
        let capableFlg = JSON.parse(localStorage.getItem('rpCapableFlg'));
        this.subMenuService.generateMenu(
            isIcmDevice,
            this.patientId,
            this.isActivatorClinic,
            this.isDtvForICM,
            capableFlg,
            this.isLPDevice
        );
    }

    showPatientName() {
        return !(this.patientName == null + ' ' + null);
    }

    translateLabel(label) {
        return this.translateService.instant(label);
    }
}
